export default __webpack_public_path__ + "images/diving-into-methods.svg";